import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useSession } from "@/providers/session-provider";

type ProtectedRouteProps = {
  children: ReactNode;
};

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { session, isSessionLoading, hasSessionError } = useSession();

  // Show loading state while session is being fetched OR when there's an error
  // (e.g. API restarting during dev). This prevents redirecting to login when
  // the API is temporarily unreachable.
  if (isSessionLoading || hasSessionError) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 animate-spin rounded-full border-gray-900 border-b-2" />
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!session?.user) {
    const redirectPath = location.pathname + location.search;
    return (
      <Navigate
        replace
        to={`/auth/login?redirect=${encodeURIComponent(redirectPath)}`}
      />
    );
  }

  return <>{children}</>;
}
